import { render, staticRenderFns } from "./MPopupArticleDetail.vue?vue&type=template&id=e41fc0c0&"
import script from "./MPopupArticleDetail.ts?vue&type=script&lang=ts&"
export * from "./MPopupArticleDetail.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports